export const EXPERTISE_ITEMS = [
  {
    icon: "01",
    title: "Strength & Conditioning",
    description: "Build strength that carries over. Progressive programming for power, performance, and long-term resilience.",
  },
  {
    icon: "02",
    title: "Post Rehabilitation",
    description: "Return to training with confidence. Smart progressions that respect injuries, limitations, and movement quality.",
  },
  {
    icon: "03",
    title: "Weight Training",
    description: "Technique-first lifting with structure. Hypertrophy, strength, and consistency without guesswork.",
  },
  {
    icon: "04",
    title: "Calisthenics",
    description: "Master control and bodyweight strength. Pull-ups, dips, levers, and clean movement patterns built step by step.",
  },
  {
    icon: "05",
    title: "Pre / Postnatal Specialist",
    description: "Supportive, safe training through every phase. Strength, posture, and core work tailored to your needs.",
  },
  {
    icon: "06",
    title: "Sports Nutrition",
    description: "Fuel for performance and physique. Simple nutrition systems that fit your lifestyle and training demands.",
  },
];

